module.exports = __webpack_public_path__ + "static/media/Donate.edb7340d.webp";